
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { IrisDynamicFormsRoutingService } from '@iris/modules/dynamic-forms/dynamic-forms-routing.service';
import { IrisDocumentByTemplateV2Service } from '@iris/common/services/dynamic-forms/document-by-template-v2.service';
import { TranslateModule } from '@ngx-translate/core';
import { combineLatest, switchMap } from 'rxjs';

@Component({
  selector: 'iris-dms-forms-link-card',
  imports: [
    RouterModule,
    MatTooltipModule,
    TranslateModule,
  ],
  templateUrl: './dms-forms-link-card.component.html',
  styleUrl: './dms-forms-link-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IrisDmsFormsLinkCardComponent {
  private readonly documentByTemplateV2Service = inject(IrisDocumentByTemplateV2Service);
  private readonly dfRoutingService = inject(IrisDynamicFormsRoutingService);

  readonly templateId = input<number>();
  readonly documentId = input<string>();

  readonly document$ = combineLatest([
    toObservable(this.templateId),
    toObservable(this.documentId),
  ]).pipe(
    switchMap(([templateId, documentId]) => this.documentByTemplateV2Service.getDocument(templateId, documentId)),
  );

  readonly document = toSignal(this.document$);

  readonly linkedFormName = computed(() => this.document()?.meta?.name);
  readonly formPath = computed(() => this.dfRoutingService.pathToDocumentView(this.document()));
}
